import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'category-insights',
  onEnter: isLoggedIn(store),
  getComponent (nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const CategoryInsights = require('./containers/CategoryInsightsContainer').default;


      /*  Return getComponent   */
      callback(null, CategoryInsights)

      /* Webpack named bundle   */
    }, 'CategoryInsightsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CategoryInsights/index.js